<template>
  <transition name="reload" mode="in-out">
    <div class="wholeContext">
      <app-sidebar></app-sidebar>
      <app-header :transDataSet="transDate"></app-header>
      <div class="appContext pb-5">
        <div class="container">
          <div class="area_wrap">
            <div
              class="result_wrap blood"
              v-if="Object.keys(this.bloodArray).length >= 1"
            >
              <div class="rw_titleWrap">
                <div class="rw_title">
                  <div
                    class="imgWrap nonReverse"
                    v-if="!view.prevNone"
                    @click.prevent="direction(false)"
                  >
                    <img src="@/assets/images/back.svg" />
                  </div>
                  <p>혈액검사결과</p>
                  <div
                    class="imgWrap reverse"
                    v-if="!view.nextNone"
                    @click.prevent="direction(true)"
                  >
                    <img src="@/assets/images/back.svg" />
                  </div>
                </div>
                <span
                  >검사일:
                  {{ checkUpArray[0].checkupDate | moment("YYYY-MM-DD") }}</span
                >
              </div>
              <div class="description">
                <p><b class="red">H</b>참고치보다 높음</p>
                <p><b class="yellow">L</b>참고치보다 낮음</p>
              </div>
              <div class="table_wrap">
                <table summary="혈액검사결과" border="1">
                  <caption>
                    혈액검사결과
                  </caption>
                  <thead>
                    <tr>
                      <th scope="col">검사명</th>
                      <th scope="col">결과</th>
                      <th scope="col">판정</th>
                      <th scope="col">참고치</th>
                    </tr>
                  </thead>
                  <tbody
                    class="present"
                    v-for="[b, i] in Object.entries(bloodArray)"
                    :key="b"
                  >
                    <tr>
                      <td scope="row">
                        <span class="title">{{ b }}</span>
                      </td>
                      <td>
                        <span class="result" v-text="i.resultValue"></span>
                      </td>
                      <td>
                        <span class="judge" v-text="i.judge"></span>
                      </td>
                      <!--                  <td>-->
                      <!--                    <span class="status"></span>-->
                      <!--                  </td>-->
                      <td class="itemInit">
                        <span class="refer">{{ i.range | hideComment }}</span>
                        <div class="expanded" v-if="i.range.length > 15">
                          <div class="img-wrap" @click="rangeClick($event)">
                            <img src="@/assets/images/keyDown.png" />
                          </div>
                          <div class="item">
                            <span v-text="i.range"></span>
                          </div>
                        </div>
                        <span
                          class="moreBtn"
                          v-if="i.history.length >= 1"
                          @click="toggleEvent(b)"
                        >
                          <img
                            :src="
                              opened.includes(b)
                                ? require(`@/assets/images/${imgUn}`)
                                : require(`@/assets/images/${imgOn}`)
                            "
                          />
                        </span>
                      </td>
                    </tr>
                    <tr
                      class="old"
                      v-if="i.history.length >= 1"
                      v-show="opened.includes(b)"
                    >
                      <td>검사일</td>
                      <td>결과</td>
                      <td>판정</td>
                    </tr>
                    <tr
                      class="old oldResult"
                      v-for="(h, i) in i.history"
                      :key="i + 'a'"
                      v-show="opened.includes(b)"
                    >
                      <td>
                        <span>{{ h.checkupDate | moment("YYYY-MM-DD") }}</span>
                      </td>
                      <td>
                        <span class="result" v-text="h.resultValue"></span>
                      </td>
                      <td>
                        <span class="judge" v-text="h.judge"></span>
                      </td>
                      <!--                  <td>-->
                      <!--                    <span class="status"></span>-->
                      <!--                  </td>-->
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="description center">
                <div class="pb-10">
                  <!--                <p>*검사 결과와 관련된 일반적인 설명(FAQ)은 <b><router-link to="/info/faq">여기</router-link></b>를 참고하세요.</p>-->
                  <p>
                    *더 자세한 설명이나 상담을 원하시는 분은 병원에 내원하셔서
                    진료를 보셔야 합니다.
                  </p>
                </div>
                <div class="small_btnWrap one">
                  <router-link to="../../reservation/explain">
                    <button type="button" class="red">예약하기</button>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="result_wrap" v-else>
              <div class="rw_titleWrap">
                <div class="rw_title">
                  <div
                    class="imgWrap nonReverse"
                    v-if="!view.prevNone"
                    @click.prevent="direction(false)"
                  >
                    <img src="@/assets/images/back.svg" />
                  </div>
                  <p class="blue">병리검사결과</p>
                  <div
                    class="imgWrap reverse"
                    v-if="!view.nextNone"
                    @click.prevent="direction(true)"
                  >
                    <img src="@/assets/images/back.svg" />
                  </div>
                </div>
                <span
                  >검사일:
                  {{ pathologyArray.checkupDate | moment("YYYY-MM-DD") }}</span
                >
              </div>
              <div class="board_wrap">
                <div class="board_body">
                  <div class="write_space detail">
                    <p v-html="pathologyArray.resultValue">내용</p>
                  </div>
                </div>
              </div>
              <div class="description center">
                <div class="pb-10">
                  <!--                <p>*검사 결과와 관련된 일반적인 설명(FAQ)은 <b><router-link to="/info/faq">여기</router-link></b>를 참고하세요.</p>-->
                  <p>
                    *더 자세한 설명이나 상담을 원하시는 분은 병원에 내원하셔서
                    진료를 보셔야 합니다.
                  </p>
                </div>
                <div class="small_btnWrap one">
                  <router-link to="../../reservation/explain">
                    <button type="button" class="red">예약하기</button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btnWrap visible">
          <button type="button" class="callTerms" @click="moveList()">
            목록
          </button>
        </div>
      </div>

      <add-popup v-if="checkPopup" :popupSet="popupSet" />
    </div>
  </transition>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import AppSidebar from "@/components/AppSidebar";
import AddPopup from "@/components/AddPopup";
import errorParser from "@/utils/error-parser";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      popupSet: {
        title: "",
        modalImg: "alert_cn.svg",
        content: "",
        confirmBtnText: "확인",
        count: "single",
      },
      transDate: {
        headerName: "검사결과 조회",
        prevUrl: "/checkup/checkupList",
      },
      checkupList: [],
      imgOn: "dropdown1.svg",
      imgUn: "dropdown2.svg",
      status: {
        normal: false,
        low: false,
        high: false,
      },
      history: false,
      show: false,
      opened: [],
      detailSet: [],
      trackIndex: "",
      nextCheckupCode: "",
      checkUpArray: [],
      bloodArray: [],
      bloodArrayValue: [],
      pathologyArray: [],
      backNum: "",
      sampleTxt:
        "남: 0.57-12.07 여: Follicular 1.80-11.78    MidCyclePeak 7.59-89.08    Luteal 0.56-14.00    Postmenopausalw/oHRT    5.16-61.99",
      view: {
        prevNone: false,
        nextNone: false,
      },
      setCount: false,
    };
  },
  computed: {
    ...mapGetters("checkup", [
      "getCheckupDetail",
      "getCheckup",
      "getCheckupList",
    ]),
    ...mapState(["checkPopup"]),
  },
  filters: {
    hideComment(val) {
      console.log("이거뭐냐?", val);
      console.log("이거 길이는?", val.length);
      if (val.length > 15) {
        return val.substring(0, 15);
      } else {
        return val;
      }
    },
  },
  methods: {
    ...mapMutations(["SET_POPUP"]),
    ...mapMutations("checkup", ["SET_CHECKUP"]),
    ...mapActions("checkup", ["CHECKUP_DETAIL"]),
    rangeClick(event) {
      const target = event.target.parentNode.parentNode;
      if (target.classList.contains("active")) {
        event.target.src = require("@/assets/images/keyDown.png");
        target.classList.remove("active");
      } else {
        event.target.src = require("@/assets/images/keyUp.png");
        target.classList.add("active");
      }
    },
    callPrev() {
      if (this.setCount) {
        this.$router.push("/checkup/checkupList");
      } else {
        history.go(1);
      }
      this.setCount = true;
      // 클로즈 함수 구현
    },
    moveList() {
      if (
        sessionStorage
          .getItem("pathFromLoadUnAuth")
          .indexOf("checkupDetail") !== -1
      ) {
        this.$router.push("/checkup/checkupList");
      } else {
        history.go(-1);
      }
    },
    toggleEvent(b) {
      console.log("b: ", b);
      const index = this.opened.indexOf(b);
      if (index > -1) {
        console.log(index);
        this.opened.splice(index, 1);
        console.log(this.opened);
      } else {
        this.opened.push(b);
      }
      // const areaArr = document.querySelectorAll('.present')
      //
      // areaArr.forEach((area) => {
      //   const content = area.querySelector('.old')
      //   const btn = area.querySelector('.moreBtn')
      //   const arrow = btn.querySelector('img')
      //
      //   btn.addEventListener('click', () => {
      //     /* 한개 열리면 다른건 접히도록 */
      //     // if (content.classList.contains('show')) {
      //     //   areaArr.forEach((el) => {
      //     //     el.childNodes[1].classList.remove('show')
      //     //   })
      //     // }
      //     arrow.classList.toggle('rotate')
      //     for (let i = 0; i < content.length; i++) {
      //       content[i].classList.toggle('show')
      //     }
      //   })
      // })
    },
    dataTransForm() {
      const result = document.querySelectorAll(".result");
      const resultList = [].slice.call(result);
      const resultValue = resultList.map(function (e) {
        return e.innerText;
      });

      const judge = document.querySelectorAll(".judge");
      const judgeList = [].slice.call(judge);
      const judgeValue = judgeList.map(function (e) {
        return e.innerText;
      });
      // console.log('resultValue: ', resultValue)
      // console.log('judgeValue: ', judgeValue)
      // console.log('judge: ', judge)

      for (let i = 0; i < resultValue.length; i++) {
        if (resultValue[i] > 10) {
        }
      }

      for (let i = 0; i < judgeValue.length; i++) {
        if (judgeValue[i] === "-") {
          this.status.normal = true;
          judge[i].classList.add("normal");
          judge[i].parentNode.classList.add("normalTd");
          judge[i].parentNode.parentNode.classList.add("normalTr");
          // judge[i].parentNode.nextSibling.childNodes[0].innerText = '정상'
        } else if (judgeValue[i] === "L") {
          this.status.normal = false;
          this.status.low = true;
          judge[i].classList.add("low");
          judge[i].parentNode.classList.add("lowTd");
          judge[i].parentNode.parentNode.classList.add("lowTr");
          // judge[i].parentNode.nextSibling.childNodes[0].innerText = '비정상'
          // judge[i].parentNode.nextSibling.childNodes[0].classList.add('lowText')
        } else if (judgeValue[i] === "H") {
          this.status.normal = false;
          this.status.low = false;
          this.status.high = true;
          judge[i].classList.add("high");
          judge[i].parentNode.classList.add("highTd");
          judge[i].parentNode.parentNode.classList.add("highTr");
          // judge[i].parentNode.nextSibling.childNodes[0].innerText = '비정상'
          // judge[i].parentNode.nextSibling.childNodes[0].classList.add('highText')
        }
      }
    },
    initBringData() {
      this.checkUpArray = [];
      const checkupDataSet = [];
      checkupDataSet.push(this.getCheckup);
      this.checkUpArray = checkupDataSet;
      console.log(
        "this.getCheckup.checkupCode",
        this.checkUpArray[0].checkupCode
      );
      const excu1 = Object.entries(this.getCheckupList);
      const keyArray1 = [];
      const valueArray1 = [];
      let location = "";
      for (const [key, value] of excu1) {
        keyArray1.push(key);
        valueArray1.push(value);
      }
      console.log("keyArray: ", keyArray1);
      console.log("valueArray: ", valueArray1);
      // 현재 트렉인덱스가 3인걸 알려줘야함
      for (let i = 0; i < this.getCheckupList.length; i++) {
        if (valueArray1[i].id === this.getCheckup.checkupCode) {
          location = i;
        }
      }
      this.backNum = Number(this.getCheckupList.length) - 1;
      this.trackIndex = location;
      if (this.trackIndex === 0) {
        this.view.prevNone = true;
      } else if (this.trackIndex === this.backNum) {
        this.view.nextNone = true;
      } else {
        this.view.prevNone = false;
        this.view.nextNone = false;
      }
      this.bloodArray = [];
      this.pathologyArray = [];
      const excu2 = Object.entries(this.getCheckupDetail);
      const keyArray2 = [];
      const valueArray2 = [];
      for (const [key, value] of excu2) {
        keyArray2.push(key);
        valueArray2.push(value);
      }
      console.log("벨류셋", valueArray2[0]);
      if (keyArray2[0] === "bloodCheckup") {
        this.bloodArray = valueArray2[0];
        console.log("담아논 혈액데이터", this.bloodArray);
      } else if (keyArray2[0] === "pathologyCheckup") {
        this.pathologyArray = valueArray2[0];
        console.log("담아논 혈액데이터", this.pathologyArray);
      }
      const sampleBlood = Object.entries(this.bloodArray);
      const sampleKeyArray = [];
      const sampleValueArray = [];
      for (const [key, value] of sampleBlood) {
        sampleKeyArray.push(key);
        sampleValueArray.push(value);
      }
      this.bloodArrayValue = sampleValueArray;
      console.log("재료", sampleValueArray[2].range.length);
      console.log("테스트", this.bloodArrayValue[1].range);
    },
    async direction(direction) {
      const currentCount = this.trackIndex;
      console.log("현재코드", currentCount);
      if (direction) {
        const linkLocation = this.getCheckupList[currentCount + 1].id;
        try {
          const requestData = {
            categoryCode: this.getCheckupList[currentCount + 1].categoryCode,
            checkupCode: this.getCheckupList[currentCount + 1].id,
            checkupDate: this.getCheckupList[currentCount + 1].checkupDate,
          };
          console.log(
            "데이터가 담긴 좌표",
            this.getCheckupList[currentCount + 1]
          );
          console.log("리퀘스트 데이터", requestData);
          this.SET_CHECKUP(requestData);
          await this.CHECKUP_DETAIL(requestData).then(() => {
            this.initBringData();
            this.$router.push(`./${linkLocation}`);
          });
        } catch (error) {
          console.log('error :', error);
          console.log("검사결과 상세보기 api에서 에러발생.");
          if (error.status !== 401) {
            this.SET_POPUP(true);
            this.popupSet.content = errorParser.parse(error);
          } else {
            await this.$router.push("/login");
          }
        } finally {
          this.dataTransForm();
        }
      } else {
        const linkLocation = this.getCheckupList[currentCount - 1].id;
        try {
          const requestData = {
            categoryCode: this.getCheckupList[currentCount - 1].categoryCode,
            checkupCode: this.getCheckupList[currentCount - 1].id,
            checkupDate: this.getCheckupList[currentCount - 1].checkupDate,
          };
          this.SET_CHECKUP(requestData);
          await this.CHECKUP_DETAIL(requestData).then(() => {
            this.initBringData();
            this.$router.push(`./${linkLocation}`);
          });
        } catch (error) {
          console.log('error :', error);
          console.log("검사결과 상세보기 api에서 에러발생.");
          if (error.status !== 401) {
            this.SET_POPUP(true);
            this.popupSet.content = errorParser.parse(error);
          } else {
            await this.$router.push("/login");
          }
        } finally {
          this.dataTransForm();
        }
      }
    },
  },
  mounted() {
    this.dataTransForm();
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup,
  },
  created() {
    if (history.pushState !== undefined) {
      history.pushState({}, "", location.href);
      window.onpopstate = () => {
        this.callPrev();
      };
    }
    console.log("순차를 돌 배열", this.getCheckupList);
    console.log("this.getCheckup", this.getCheckup);
    console.log("this.getCheckup.categoryCode", this.getCheckup.categoryCode);
    if (this.getCheckup.categoryCode !== "") {
      if (this.getCheckup.categoryCode === 0) {
        console.log("혈액진입");
      } else {
        console.log("병리진입");
      }
    }
    this.initBringData();
  },
  beforeDestroy() {
    this.SET_POPUP(false);
    this.setCount = false;
  },
};
</script>

<style lang="scss" scoped>
.result_wrap .table_wrap table tbody tr td.itemInit {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  span.refer {
    width: 100%;
    display: block;
    position: relative;
    padding: 0;
  }
}
.expanded {
  position: relative;
  width: 100%;
  &.active {
    .item {
      width: 179px;
      height: 130px;
      bottom: -130px;
      left: -89px;
      padding: 10px;
      background: #f0f0f0;
      color: #5b5b5b;
      display: flex;
      justify-content: center;
      border-radius: 6.5px;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      border: 0;
      overflow-y: scroll;
      z-index: 11;
      span {
        position: relative !important;
        top: inherit !important;
        right: inherit !important;
        display: block !important;
        width: 100% !important;
      }
    }
  }
  .img-wrap {
    width: 19px;
    max-height: 19px;
    margin: 2px auto 0;
    img {
      max-width: 100%;
    }
  }
  .item {
    display: none;
    position: absolute;

    span {
    }
  }
}
</style>
